import React, { Component } from 'react';
import { VehicleDetails } from './VehicleDetails';
import ReactDOM from "react-dom";

export class VehicleDetailsCard extends Component{

    constructor(props){
        super(props);
        var newInput = JSON.parse(JSON.stringify(VehicleDetails.defaultVehicleInputData));
        this.state = {            
            vehicleInputData: [newInput]
        };
        //TODO: Need to rerender children with the appropriate state, and hold all of the data needed
        // to repopulate the input fields because there doesn't seem to be an easy way for data
        // to be shared horizontally
        // Doing this now, before we need to use Redux.

        this.addVehicle = this.addVehicle.bind(this);
        this.removeVehicle = this.removeVehicle.bind(this);
        this.onUpdate = this.onUpdate.bind(this);
        this.onUpdateMultiple = this.onUpdateMultiple.bind(this);
    }

    componentDidMount(){
        /*const node = ReactDOM.findDOMNode(this);
        node.scrollIntoView({behavior: "smooth", block: "nearest", inline: "start"});*/
    }

    onUpdateMultiple = (id, keyValuePairs) => {
        var vehicleInputData = this.state.vehicleInputData;
        keyValuePairs["keys"].map((key,index) => vehicleInputData[id][key] = keyValuePairs["values"][index]);
        this.setState({vehicleInputData: vehicleInputData});
    }
    onUpdate = (id,key,value) =>{
        var vehicleInputData = this.state.vehicleInputData;
        vehicleInputData[id][key] = value;
        this.setState({vehicleInputData: vehicleInputData});
    }

    addVehicle = () =>
    {
        var vehicleInputData = this.state.vehicleInputData;
        if(vehicleInputData.length < parseInt(this.props.maxVehicles, 10))
        {
            var newInput = JSON.parse(JSON.stringify(VehicleDetails.defaultVehicleInputData));
            vehicleInputData.push(newInput);
        }
        this.setState({vehicleInputData: vehicleInputData});
    }

    removeVehicle = (index) =>
    {
        var vehicleInputData = this.state.vehicleInputData;
        var numVehicles = vehicleInputData.length;
        if(index < numVehicles && index >= 0)
        {
            vehicleInputData.splice(index,1);
        }
        this.setState({vehicleInputData: vehicleInputData});
    }

    render(){
        var id = 0;
        var numVehicles = this.state.vehicleInputData.length;
        var vehicleDetailsList = this.state.vehicleInputData.map((element) => 
            <div key={id} className="col-sm-12 col-md-6 mb-2">
                <div className="card border border-secondary p-2">
                    <VehicleDetails id={id++} inputFor="vehicleInfo" 
                        onRemoveVehicle={this.removeVehicle} value={element} onUpdate={this.onUpdate}
                        onUpdateMultiple={this.onUpdateMultiple}
                        totalVehicles={numVehicles}/>
                </div>
            </div>
        );
        return(
            <div className="col-12">   
                <div className="card border border-dark p-2">
                    <div className="display-5 mb-2">Vehicle Details</div>
                    <div className="row">
                        
                        <div className="col-12 mb-1">
                            Total Vehicles: {this.state.vehicleInputData.length}
                        </div>
                        <div className="col-12 mb-1">
                            <button type="button" className="btn btn-success" onClick={() => this.addVehicle()}>Add vehicle</button>
                        </div>
                        
                        {vehicleDetailsList}

                    </div>      
                </div>
            </div>
        )
    }
}